import "./MarketMoversComponent.scss";
import template from "./MarketMoversComponent.html";
import {IComponentOptions, IRootElementService} from "angular";
import {BehaviorSubject, Observable, ReplaySubject} from "rxjs";
import {MarketMoversStore} from "../../store/MarketMoversStore";
import {MarketMoversType} from "../../types/MarketMoversType";
import {ComponentCallback} from "../../../../types/AngularJS";
import {MarketMoverModels, MarketMoversModel} from "../../models/MarketMoversStateModel";

export const MarketMovers = "tfMarketMovers";

export function marketMovers(): IComponentOptions {
    return {
        template,
        bindings: {
            type: "<",
            onClick: "&"
        },
        controllerAs: "ctrl",
        controller: MarketMoversComponentController
    };
}

type View = "gainers" | "losers";

export class MarketMoversComponentController {

    /** @input */
    public set type(type: MarketMoversType | null) {
        if (type == null) {
            this.type$.next("top200");
        } else {
            this.type$.next(type);
        }
    }

    private readonly type$ = new ReplaySubject<MarketMoversType>(1);

    /** @output */
    public readonly onClick: ComponentCallback;

    public readonly hasOnClick: boolean;
    public readonly currentView$ = new BehaviorSubject<View>("gainers");
    public readonly movers$: Observable<MarketMoverModels>;

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly marketMoversStore: MarketMoversStore) {
        this.hasOnClick = $element.attr("on-click") != null;
        this.movers$ = this.buildMovers();
    }

    private buildMovers(): Observable<MarketMoverModels> {
        const type$ = this.typeSource();
        const source$ = Observable.combineLatest(type$, this.currentView$);
        return source$.map(([movers, view]) => {
            if (view === "gainers") {
                return movers.gainers;
            } else {
                return movers.losers;
            }
        });
    }

    private typeSource(): Observable<MarketMoversModel> {
        return this.type$
                   .distinctUntilChanged()
                   .switchMap((type) => {
                       if (type === "all") {
                           return this.marketMoversStore.all;
                       } else {
                           return this.marketMoversStore.top200;
                       }
                   });
    }

    public selectView(view: View) {
        this.currentView$.next(view);
    }
}
